const routeConfig = {
  trade: '/trade',
  tradeChart: '/trade/chart',
  openPositions: '/trade/open-positions',
  tradingHistory: '/trade/history',
  lend: '/lend',
  lendAsset: '/lend/asset',
  lendYields: '/lend/yields',
  stats: '/stats',
  reserve: '/stats/reserve',
  treasury: '/stats/treasury',
  activity: '/stats/activity',
}

export default routeConfig
